function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M11.3359713,14.9678929 C11.555785,14.9893311 11.7771092,15 12,15 C14.1263341,15 16.1100988,14.0290469 18,12 C17.3520759,11.3043719 16.6931195,10.7331077 16.0211682,10.282696 L11.3359713,14.9678929 Z M17.553058,8.75080618 C18.7543253,9.55608284 19.903306,10.6391474 21,12 C18.3137085,15.3333333 15.3137085,17 12,17 C11.1834422,17 10.3859334,16.8987969 9.60747361,16.6963906 L7.30386419,19 L5.82789322,17.524029 L18.3519222,5 L19.8278932,6.47597098 L17.553058,8.75080618 Z M5.76564929,14.7583797 C4.80951426,14.0208931 3.88763116,13.1014332 3,12 C5.6862915,8.66666667 8.6862915,7 12,7 C12.4796615,7 12.9527499,7.03492125 13.4192653,7.10476376 L11.5063629,9.0176661 C9.56561248,9.15745696 7.74289184,10.1287862 6,12 C6.42949411,12.461116 6.8638359,12.8675858 7.30359701,13.220432 L5.76564929,14.7583797 Z"
});

var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hide.fdc81b0b.svg";
export { ForwardRef as ReactComponent };